import { createContext } from 'react';

import { AppDomainContextType } from './types';

export const AppDomainContext = createContext<AppDomainContextType>(null);
